import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="mb-12">
          <Link to="/" className="inline-flex items-center gap-2 cursor-pointer">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </span>
            <span className="font-heading text-3xl text-background-50">韩漫漫画网</span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-14">
          <div>
            <p className="text-sm text-background-50/70 leading-relaxed max-w-xs">
              韩漫漫画网 - 您的免费韩国漫画在线阅读平台。每日更新海量韩漫资源，智能推荐发现新喜好。从恋爱甜宠到热血冒险，总有一部适合你。
            </p>
            <div className="flex items-center gap-4 mt-6">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-tiktok-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 cursor-pointer transition-colors"
                  aria-label="社交媒体"
                  rel="nofollow"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="space-y-5">
            <div>
              <h4 className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-1">地址</h4>
              <p className="text-sm text-background-50/70">中国北京市朝阳区漫画大厦 1008 室</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-1">电话</h4>
              <p className="text-sm text-background-50/70">+86 400-888-6666</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-1">邮箱</h4>
              <p className="text-sm text-background-50/70">hello@linxituan.com</p>
            </div>
          </div>

          <div>
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20illustration%20style%20art%2C%20colorful%20comic%20panels%20collage%2C%20warm%20vibrant%20colors%2C%20modern%20digital%20art%2C%20manga%20and%20webtoon%20aesthetic%2C%20creative%20artistic%20composition%2C%20soft%20gradient%20background%2C%20clean%20design&width=600&height=400&seq=footer-banner-01&orientation=landscape"
                alt="韩漫漫画网精彩推荐"
                title="韩漫漫画网 - 发现更多精彩韩漫"
                className="w-full h-48 object-cover"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">© 2026 韩漫漫画网 版权所有</p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-background-50/40 hover:text-background-50/70 cursor-pointer transition-colors whitespace-nowrap">服务条款</Link>
            <Link to="/about" className="text-xs text-background-50/40 hover:text-background-50/70 cursor-pointer transition-colors whitespace-nowrap">隐私政策</Link>
            <Link to="/about" className="text-xs text-background-50/40 hover:text-background-50/70 cursor-pointer transition-colors whitespace-nowrap">联系我们</Link>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="text-xs text-background-50/30 hover:text-background-50/60 cursor-pointer transition-colors whitespace-nowrap"
            >
              {cat.name}漫画
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}